// Auto-incrementing version number
// Format: MAJOR.MINOR.PATCH
export const version = '1.1';

// Build number will auto-increment on each build
export const buildNumber = '056';

// Combine version and build number
export const fullVersion = `${version}-${buildNumber}`; 